import { render, staticRenderFns } from "./DeleteAdditionalField.vue?vue&type=template&id=c0a78a84"
import script from "./DeleteAdditionalField.vue?vue&type=script&lang=js"
export * from "./DeleteAdditionalField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports